module.exports = __webpack_public_path__ + "img/candy_cane.c8415963.svg";